<template lang="html">
<v-tooltip
class="mr-0"
bottom>
    <v-btn
    slot="activator"
    @click="toggle"
    icon>
        <v-badge
        :value="numActiveFilters > 0"
        right
        color="yellow darken-4"
        overlap>
            <v-icon slot="badge" dark>filter_list</v-icon>
            <v-icon large>more_vert</v-icon>
        </v-badge>
    </v-btn>
    <span v-html="tooltipText"></span>
</v-tooltip>
</template>

<script>
import { SHOW_MAP_SIDEBAR } from '@/constants/actions';
import pluralize from 'pluralize';

export default {
    name: 'sidebar-toggle',
    computed: {
        show: {
            get() {
                return this.$store.state.sidebar.show;
            },
            set(val) {
                this.$store.dispatch(SHOW_MAP_SIDEBAR, val);
            },
        },
        tooltipText() {
            let tooltip = '';
            const numFilters = this.numActiveFilters;

            if (this.show) {
                tooltip += 'Hide side panel';
            } else {
                tooltip += 'Show side panel';
            }

            if (numFilters > 0) {
                tooltip += ` <br>(${numFilters} ${pluralize('filters', numFilters)} active)`;
            }

            return tooltip;
        },
        // number of filters a non-default value set
        numActiveFilters() {
            const activeFilters = Object.keys(this.$store.state.filterSettings);
            return activeFilters.length;
        },
    },
    methods: {
        /**
         * show/hide the sidebar
         */
        toggle() {
            this.show = !this.show;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/SidebarToggle.vue